import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";

export default {
  getAccounts() {
    return apiService.get(endpoints.googlePlay.accounts);
  },
  createGooglePlayAccount(token) {
    return apiService.post(endpoints.googlePlay.accounts, { code: token });
  },
  deleteAccount(accountId) {
    return apiService.delete(endpoints.googlePlay.deleteAccount(accountId));
  },
  createApp(data) {
    return apiService.post(endpoints.googlePlay.apps, data);
  },
  deleteApp(appId) {
    return apiService.delete(endpoints.googlePlay.deleteApp(appId));
  },
  getApps(accountId) {
    return apiService.get(
      endpoints.googlePlay.apps + (accountId ? `?account=${accountId}` : "")
    );
  }
};
